import { IconConfig } from '..';

/* tslint:disable:max-line-length */
export const vendorSearch: IconConfig = {
  name: 'vendorSearch',
  a11yLabel: 'Vendor Search',
  viewBox: 48,
  fill: '#333333',
  body: `  
    <circle cx="20" cy="20" r="16.25"  stroke-width="1.5"/>
    <line x1="32.0607" y1="32" x2="43" y2="42.9393"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21 32C13.8203 32 8 26.1797 8 19"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  `
};
